<div class="pageHeight">
  <sh-page theme={{theme_color}} class="manageFolder">
    <sh-grid>
      <div label='Business' columns="3" [ngStyle]="{'background':theme_color==='dark'?'#2d2d2d':'#F5F5F5'}">
        <sh-text label='Create Business' class="headetText">Create Business
          <sh-icon icon="plus" size="s" class="plusIcon" (click)="createBusinessStructure('Business')"></sh-icon>
        </sh-text>
        <sh-search label="Search Business" (search)="searchBusiness($event)" [(value)]="searchKeyBusiness"
          (clearsearch)="reset()" class="search"></sh-search>
        <div class="category">
          <ng-container *ngIf="businessStructure!==undefined && !searchBusinessFlag">
            <ng-container *ngFor="let folder of businessStructure?.subFolders">
              <sh-text (click)="getProductFamilyFolders(folder)" class="folderName"
                [ngClass]="{'selectFolder': folder.selected==true, 'unselectFolder': !folder.selected}">{{folder.name}}
                <ng-container *ngIf="folder.selected==true">
                  <sh-icon icon="edit" size="xs" class="icon" (click)="editFolder('Business', folder)"></sh-icon>
                  <sh-icon icon="image" size="xs" class="displayIcon" (click)="displayImage('Business', folder)">
                  </sh-icon>
                  <sh-icon icon="delete" size="xs" class="deleteIcon"
                    (click)="deleteBusinessStructure(folder,'Business')">
                  </sh-icon>
                </ng-container>
              </sh-text>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="businessStructureSearch?.subFolders!==[] && this.searchBusinessFlag">
            <ng-container *ngFor="let folder of businessStructureSearch?.subFolders">
              <sh-text (click)="getProductFamilyFolders(folder)" class="folderName"
                [ngClass]="{'selectFolder': folder.selected==true, 'unselectFolder': !folder.selected}">{{folder.name}}

                <ng-container *ngIf="folder.selected==true">
                  <sh-icon icon="edit" size="xs" class="icon" (click)="editFolder('Business', folder)"></sh-icon>
                  <sh-icon icon="image" size="xs" class="displayIcon" (click)="displayImage('Business', folder)">
                  </sh-icon>
                  <sh-icon icon="delete" size="xs" class="deleteIcon"
                    (click)="deleteBusinessStructure(folder,'Business')">
                  </sh-icon>
                </ng-container>
              </sh-text>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div label='Product Family' columns="3" [ngStyle]="{'background':theme_color==='dark'?'#2d2d2d':'#F5F5F5'}">
        <sh-text label='Create Business' class="headetText">Create ProductFamily
          <sh-icon icon="plus" size="s" class="plusIcon" (click)="createBusinessStructure('ProductFamily')"
            [disabled]="showProductFamily==false"></sh-icon>
        </sh-text>
        <sh-search label="Search ProductFamily" (search)="searchProductFamily($event)"
          [(value)]="searchKeyProductFamily" (clearsearch)="resetProductFamily()" [disabled]="showProductFamily==false"
          class="search"></sh-search>
        <div class="category">
          <ng-container *ngIf="productFamily!==undefined && showProductFamily==true && !searchProductFamilyFlag">
            <ng-container *ngFor="let folder1 of productFamily?.subFolders">

              <sh-text (click)="getProductFolders(folder1)" class="folderName"
                [ngClass]="{'selectFolder': folder1.selected==true, 'unselectFolder': !folder1.selected}">
                {{folder1.name}}
                <ng-container *ngIf="folder1.selected==true">
                  <sh-icon icon="edit" size="xs" class="icon" (click)="editFolder('ProductFamily', folder1)"></sh-icon>
                  <sh-icon icon="delete" size="xs" class="deleteIcon"
                    (click)="deleteBusinessStructure(folder1,'ProductFamily')">
                  </sh-icon>
                </ng-container>
              </sh-text>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="productFamily!==undefined && showProductFamily==true && searchProductFamilyFlag">
            <ng-container *ngFor="let folder1 of productFamilySearch?.subFolders">
              <sh-text (click)="getProductFolders(folder1)" class="folderName"
                [ngClass]="{'selectFolder': folder1.selected==true, 'unselectFolder': !folder1.selected}">
                {{folder1.name}}
                <ng-container *ngIf="folder1.selected==true">
                  <sh-icon icon="edit" size="xs" class="icon" (click)="editFolder('ProductFamily', folder1)"></sh-icon>
                  <sh-icon icon="delete" size="xs" class="deleteIcon"
                    (click)="deleteBusinessStructure(folder1,'ProductFamily')">
                  </sh-icon>
                </ng-container>
              </sh-text>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div label='Product' columns="3" [ngStyle]="{'background':theme_color==='dark'?'#2d2d2d':'#F5F5F5'}">
        <sh-text label='Create Business' class="headetText">Create Product
          <sh-icon icon="plus" size="s" class="plusIcon" (click)="createBusinessStructure('Product')"
            [disabled]="showProduct==false"></sh-icon>
        </sh-text>
        <sh-search label="Search Product" (search)="searchProduct($event)" [(value)]="searchKeyProduct"
          (clearsearch)="resetProduct()" class="search" [disabled]="showProduct==false"></sh-search>
        <div class="category">
          <ng-container *ngIf="product!==undefined && showProduct==true && !searchProductFlag">
            <ng-container *ngFor="let folder2 of product?.subFolders">

              <sh-text (click)="getConfiguarionFolders(folder2)" class="folderName"
                [ngClass]="{'selectFolder': folder2.selected==true, 'unselectFolder': !folder2.selected}">
                {{folder2.name}}
                <ng-container *ngIf="folder2.selected==true">
                  <sh-icon icon="edit" size="xs" class="icon" (click)="editFolder('Product', folder2)"></sh-icon>
                  <sh-icon icon="delete" size="xs" class="deleteIcon"
                    (click)="deleteBusinessStructure(folder2,'Product')">
                  </sh-icon>
                </ng-container>
              </sh-text>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="product!==undefined && showProduct==true && searchProductFlag">
            <ng-container *ngFor="let folder2 of productSearch?.subFolders">
              <sh-text (click)="getConfiguarionFolders(folder2)" class="folderName"
                [ngClass]="{'selectFolder': folder2.selected==true, 'unselectFolder': !folder2.selected}">
                {{folder2.name}}
                <ng-container *ngIf="folder2.selected==true">
                  <sh-icon icon="edit" size="xs" class="icon" (click)="editFolder('Product', folder2)"></sh-icon>
                  <sh-icon icon="delete" size="xs" class="deleteIcon"
                    (click)="deleteBusinessStructure(folder2,'Product')">
                  </sh-icon>
                </ng-container>
              </sh-text>
            </ng-container>
          </ng-container>
        </div>
      </div>
      <div label='Configuration' columns="3" [ngStyle]="{'background':theme_color==='dark'?'#2d2d2d':'#F5F5F5'}">
        <sh-text label='Create Business' class="headetText">Create Configuration
          <sh-icon icon="plus" size="s" class="plusIcon" (click)="createBusinessStructure('Configuration')"
            [disabled]="showConfiguartion==false"></sh-icon>
        </sh-text>
        <sh-search label="Search Configuration" (search)="searchConfiguration($event)"
          [(value)]="searchKeyConfiguration" (clearsearch)="resetConfiguration()" class="search"
          [disabled]="showConfiguartion==false"></sh-search>
        <div class="category">
          <ng-container *ngIf="configuration!==undefined && showConfiguartion==true && !searchConfigurationFlag">
            <ng-container *ngFor="let folder11 of configuration?.subFolders">

              <sh-text class="folderName" (click)="getConfiguration(folder11)"
                [ngClass]="{'selectFolder': folder11.selected==true, 'unselectFolder': !folder11.selected}">
                {{folder11.name}}
                <ng-container *ngIf="folder11.selected==true">
                  <sh-icon icon="edit" size="xs" class="icon" (click)="editFolder('Configuration', folder11)"></sh-icon>
                  <sh-icon icon="delete" size="xs" class="deleteIcon"
                    (click)="deleteBusinessStructure(folder11,'Configuration')">
                  </sh-icon>
                </ng-container>
              </sh-text>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="configuration!==undefined && showConfiguartion==true && searchConfigurationFlag">
            <ng-container *ngFor="let folder11 of configurationSearch?.subFolders">
              <sh-text class="folderName" (click)="getConfiguration(folder11)"
                [ngClass]="{'selectFolder': folder11.selected==true, 'unselectFolder': !folder11.selected}">
                {{folder11.name}}
                <ng-container *ngIf="folder11.selected==true">
                  <sh-icon icon="edit" size="xs" class="icon" (click)="editFolder('Configuration', folder11)"></sh-icon>
                  <sh-icon icon="delete" size="xs" class="deleteIcon"
                    (click)="deleteBusinessStructure(folder11,'Configuration')">
                  </sh-icon>
                </ng-container>
              </sh-text>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </sh-grid>
    <sh-modal id="folderCreationModal" label='Create Folder' modal-height='auto' modal-width='320px'>
      <ng-container *ngIf="isFolderCreation">
        <p>Folder Created Successfully</p>
      </ng-container>
      <ng-container *ngIf="isModificationError">
        <p>Some Error Occured.</p>
      </ng-container>
      <ng-container *ngIf="isModification">
        <p>Folder Modified Successfully</p>
      </ng-container>
      <ng-container *ngIf="folderNameError">
        <p>Please enter the Folder Name</p>
      </ng-container>
      <ng-container *ngIf="folderNameExists">
        <p>The entered Folder Name exists. Please enter a different Folder Name</p>
      </ng-container>
      <sh-input-text label='Folder Name' [value]=folderName (value-changed)="folderName=$event.target.value"
        [error]="folderNameError || folderNameExists" id="newFolderName2"
        (blur)="folderNameError = (folderName === '' || folderName.trim() === '');folderNameValidation($event.target.value)"
        [disabled]="isFolderCreation || isModification" name="ab"></sh-input-text>
      <sh-tooltip *ngIf="folderNameError" label="Please enter the Folder Name" target="newFolderName2"
        placement="bottom-left" variation="short"></sh-tooltip>
      <sh-tooltip *ngIf="!folderNameExists && !folderNameError"
        label="Folder name can only contain '-','_' as special characters. Folder name cannot start or end with '-','_'"
        target="newFolderName2" placement="bottom-left" variation="short"></sh-tooltip>
      <sh-tooltip *ngIf="folderNameExists" label="The entered Folder Name exists. Please enter a different Folder Name"
        target="newFolderName2" placement="bottom-left" variation="short"></sh-tooltip>
      <sh-button color='primary' slot='footer' label='Save' id="saveFolder" name="ab" (click)="addNewFolder()"
        [disabled]="isFolderCreation || isModification"></sh-button>
      <sh-button color='tertiary' slot='footer' label='Cancel'
        onclick="document.querySelector('#folderCreationModal').visible = false"></sh-button>
    </sh-modal>
    <sh-modal id="folderDeletionModal" label='Delete Folder' modal-height='auto' modal-width='320px'
      name="deletionFolder" [type]="modalType">
      <ng-container *ngIf="deletedErrorflag">
        <p>{{deletedError}}</p>
        <br>
      </ng-container>
      <ng-container *ngIf="deletedFolder">
        <p>Folder deleted successfully.</p>
        <br>
      </ng-container>
      <div *ngIf="!deletedFolder">
        Are you sure you want to delete this folder?
      </div>
      <ng-container *ngIf="!deletedErrorflag">
        <sh-button color='primary' slot='footer' label='Delete' (click)="folderDeletion()" [disabled]="deletedFolder">
        </sh-button>
      </ng-container>
      <sh-button color='tertiary' slot='footer' label='Close'
        onclick="document.querySelector('#folderDeletionModal').visible = false"></sh-button>
    </sh-modal>

    <sh-modal id="displayImageModal" label='Display Image' modal-height='auto' modal-width='700px' name="displayImage">
      <sh-text>Selected business line : {{selectedBUnit?.name}}</sh-text>
      <br>
      <div class="imageContainer">
        <img [src]="preview" alt="Default Image">
      </div>
      <br>
      <input class="display-none" type="file" id="browseFile" #browseFile
        (change)="selectPreviewImage($event)">
      <sh-button shape="pill-m" label="Browse Image" for="browseFile" id="browseImage" (click)="openBrowseWindow()">
      </sh-button>
      <sh-button color='tertiary' slot='footer' label='Upload' [disabled]='previewImage.length == 0' (click)="addDisplayImage()" onclick="document.querySelector('#displayImageModal').visible = false"></sh-button>
      <sh-button color='tertiary' slot='footer' label='Close' onclick="document.querySelector('#displayImageModal').visible = false"></sh-button>
    </sh-modal>

  </sh-page>
</div>